import React from 'react';
import { Box } from '@mui/material';
import { AIWidgetLoader } from 'components/widgetParts/AIWidgetLoader';
import { AIResponseType } from 'system/AIResponseTypes';
import { useDashboard } from 'routes/dashboard/Dashboard';
import withQueryWidget, { WithQueryWidgetProps } from 'components/widgetParts/queryWidgetComposition/withQueryWidget';

function AISocialPersonasStructured(props: WithQueryWidgetProps): JSX.Element {
  const dashboard = useDashboard();

  return (
    <Box>
      <AIWidgetLoader
        {...props}
        dashboard={dashboard}
        canSaveWidgetCache={dashboard._modifiable}
        responseType={AIResponseType.PERSONAS}
      />
    </Box>
  );
}

export default withQueryWidget(AISocialPersonasStructured, {
  hasSettingsDialog: false,
  hasQueryDialog: true,
  hideDataExports: true,
  showPDFExport: true,
});
